import React from "react";
import "./WhyContactOglitz.css";

import VerifiedIcon from "@mui/icons-material/Verified";
import GroupsIcon from "@mui/icons-material/Groups";
import PublicIcon from "@mui/icons-material/Public";
import SecurityIcon from "@mui/icons-material/Security";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import TimelineIcon from "@mui/icons-material/Timeline";

const WhyContactOglitz = () => {
  return (
    <section className="oglitz-why-contact">
      <div className="oglitz-why-contact-container">
        {/* HEADER */}
        <div className="oglitz-why-contact-header">
          <span className="oglitz-why-contact-badge">Why Oglitz</span>

          <h2>
            Why Contact <span>Oglitz Software</span>
          </h2>

          <p>
            We don’t just respond — we listen, understand, and deliver with
            clarity, commitment, and confidence.
          </p>
        </div>

        {/* GRID */}
        <div className="oglitz-why-contact-grid">
          <div className="oglitz-why-card">
            <VerifiedIcon />
            <h4>Proven Expertise</h4>
            <p>
              Experienced engineers delivering scalable, secure, and modern
              digital solutions.
            </p>
          </div>

          <div className="oglitz-why-card">
            <GroupsIcon />
            <h4>Dedicated Teams</h4>
            <p>Focused teams aligned with your business goals from day one.</p>
          </div>

          <div className="oglitz-why-card">
            <PublicIcon />
            <h4>Global Presence</h4>
            <p>India & Dubai operations supporting clients across regions.</p>
          </div>

          <div className="oglitz-why-card">
            <SecurityIcon />
            <h4>Data Confidentiality</h4>
            <p>Strong data protection practices and NDA-ready engagements.</p>
          </div>

          <div className="oglitz-why-card">
            <SupportAgentIcon />
            <h4>Responsive Communication</h4>
            <p>Clear, timely updates with a human-first approach.</p>
          </div>

          <div className="oglitz-why-card">
            <TimelineIcon />
            <h4>On-Time Delivery</h4>
            <p>
              Structured execution ensuring predictable and reliable delivery.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyContactOglitz;
